import { gql } from "urql";

export const BULK_CHANGE_VIOLATION_STATUS = gql`
  mutation BulkChangeViolationStatus($status: String, $violationIds: [String]) {
    bulkChangeViolationStatus(status: $status, violationIds: $violationIds) {
      id
    }
  }
`;
